import { BusinessObjectBase } from './base';
import type { ProcessDesign } from './process-design';

export interface ProcessDesignHistoryData {
  readonly id: string;
  readonly eventType: string;
  readonly data?: any;
  readonly timestamp?: Date;
  readonly processDesignId: number;
  readonly processDesign?: ProcessDesign;
}

export interface ProcessDesignHistory extends Readonly<ProcessDesignHistoryData> {}
export class ProcessDesignHistory extends BusinessObjectBase {
  static readonly entityName = 'ProcessDesignHistory' as const;
  static readonly plural = 'process-design-histories';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<ProcessDesignHistory[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new ProcessDesignHistory(data));
  }

  static async findOne(filter?: any): Promise<ProcessDesignHistory | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new ProcessDesignHistory(data) : null;
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessDesignHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new ProcessDesignHistory(data);
  }

  static async create(
    data: Omit<ProcessDesignHistoryData, 'id'>,
  ): Promise<ProcessDesignHistory> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new ProcessDesignHistory(result);
  }

  static async updateById(
    id: string,
    data: Partial<ProcessDesignHistoryData>,
  ): Promise<ProcessDesignHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new ProcessDesignHistory(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
